<template>
  <section id="about" class="section">
    <div class="content-670">
      <h2 class="title">CONÓCEME</h2>
      <div class="section-des">Extrovertido, Optimista, Amante del deporte, la música y freaky tecnológico.</div>
    </div>
    <img
      class="about-img block-right jarallax-about jarallax"
      data-jarallax-element="-10 0"
      src="../assets/about_bg.jpg"
      alt
    />
    <div class="about-text content-670">
      <p>Nacido en el departamento del Atlántico, Barranquilla. El 20 de julio de 1987 pase a vivir a SANTA MARTA ciudad en la cual estudie mi primaria y toda mi segundaria académica, en la SAMARIA, inicio mi consumo tecnológico, todo de la mano de mi madre, que con solo 10 años me regalaría mi primer libro de programación.</p>
      <p>De hay pase A Barranquilla (Mi Quilla) como le decimos coloquialmente, en donde termine mis estudios de pregrado y posgrado en la Universitaria de la Costa (UniCosta), obteniendo el título y grado honorifico como Ingeniería de Sistemas especialistas en convergencia de redes, gracias a la tesis y libro en investigación aplicada titulado: Servidores De Comunicación Unificadas. Mi primer libro.</p>
      <p>Ya Desde el 2010 pase a vivir en Montería, Medellín, Villavicencio, Bucaramanga, Armadía y por supuesto la capital, Bogotá. Forjando así mis conocimientos en la escena laboral, aportando tecnológicamente a proyectos en toda Colombia.</p>
      <p>De Bogotá pase a vivir a Panamá, México y Guatemala, expandiendo mis conocimientos, y un poco mis fronteras.</p>
      <p>Gracias a estas experiencias he aprendido las grandes bases del trabajo en equipo y a re-valorar el carácter con cara a mi futuro personal, familiar y laboral.</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "page-about",
  data() {
    return {
      msn: "Pagína About"
    };
  }
};
</script>
